import { FunctionComponent } from 'react';
import { Box, Loader } from '@rsos/base-components';

interface Props {
  message?: string;
}

export const LoadingIndicator: FunctionComponent<Props> = ({ message }) => {
  return (
    <Box align="center" justify="center" flex={1}>
      <Loader fluid text={message} noText={!message} />
    </Box>
  );
};
